import { useEffect, useRef, type ReactNode } from 'react'

import { AccessGatewayError, type AccessGateway } from '../../domain/access'
import { AccessPage } from './AccessPage'
import { RecoveryLock } from './RecoveryLock'
import { sessionStore } from './sessionStore'

export function SessionGuard({
  gateway,
  children,
}: {
  gateway: AccessGateway
  children: ReactNode
}) {
  const { session, accessState, clearSession, markRevoked } = sessionStore()
  const verifiedSession = useRef<string | null>(null)

  useEffect(() => {
    if (!session || verifiedSession.current === session.sessionId) return
    verifiedSession.current = session.sessionId
    void gateway.refresh(session.sessionId).catch((error: unknown) => {
      if (error instanceof AccessGatewayError && error.code === 'REVOKED') markRevoked()
    })
  }, [gateway, markRevoked, session])

  if (!session || accessState === 'signed_out') return <AccessPage gateway={gateway} />

  if (accessState === 'revoked') {
    return <RecoveryLock onAuthenticate={clearSession} />
  }

  return children
}
